import React, { useState, useEffect } from "react";
import "./customRadioButton.css";
import tick from "../../assets/icons8-tick-100.png";

const CustomRadioButton = ({
  isCorrect,
  answer,
  isSelected,
  onSelect,
  isSummary,
  selectedAnswer,
  correctAnswer,
  questionPassed,
  questionAnsweredCorrectly,
}) => {
  const [multipleAnswersSelected, setMultipleAnswersSelected] = useState(false);
  const [answerIsCorrect, setAnswerIsCorrect] = useState(false);

  useEffect(() => {
    const checkMultipleQuestions = () => {
      if (isSummary) {
        if (selectedAnswer?.length > 1) {
          setMultipleAnswersSelected(true);
        } else {
          setMultipleAnswersSelected(false);
        }
      }
    };
    checkMultipleQuestions();
  }, [selectedAnswer]);

  useEffect(() => {
    const checkCorrectAnswer = () => {
      if (
        selectedAnswer?.length === 1 &&
        selectedAnswer.includes(correctAnswer.toString())
      ) {
        setAnswerIsCorrect(true);
      } else {
        setAnswerIsCorrect(false);
      }
    };

    checkCorrectAnswer();
  }, []);

  if (isSummary) {
    return (
      <div className="flex">
        <div className="radio-button-outer flex justify-center items-center mr-4 mt-4">
          {isSelected && <div className="radio-button-inner-selected "></div>}
          {!questionAnsweredCorrectly &&
            isCorrect &&
            !multipleAnswersSelected && (
              <div className="radio-button-inner "></div>
            )}

          {questionPassed && !multipleAnswersSelected && (
            <div className="radio-button-inner-passed"></div>
          )}
        </div>
        <div className="mt-4">
          <p dangerouslySetInnerHTML={{ __html: answer }} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <div
        onClick={onSelect}
        className="radio-button-outer flex justify-center items-center mr-4 mt-4"
      >
        {isSelected && <div className="radio-button-inner bg-green"></div>}
      </div>
      <div className="mt-4">
        <p dangerouslySetInnerHTML={{ __html: answer }} />
      </div>
    </div>
  );
};

export default CustomRadioButton;
